// Modules
import Script from "next/script";

export function AppIntegrationScripts() {
    return (
        <>
            <Script
                id="gtm"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}');
                `
                }}
            />
            <Script
                type="text/javascript"
                id="zohodeskasap"
                dangerouslySetInnerHTML={{
                    __html: `
                    var d=document; s=d.createElement("script"), s.type="text/javascript", s.id="zohodeskasapscript", s.defer=true, s.src="https://desk.zoho.eu/portal/api/web/asapApp/174844000000939003?orgId=20099314522", t=d.getElementsByTagName("script")[0], t.parentNode.insertBefore(s,t), window.ZohoDeskAsapReady=function(s){ var e=window.ZohoDeskAsapasyncalls=window.ZohoDeskAsapasyncalls||[]; window.ZohoDeskAsapReadyStatus?(s&&e.push(s),e.forEach(s=>s&&s()),window.ZohoDeskAsap__asyncalls=null):s&&e.push(s) }`
                }}
            />
        </>
    );
}

export function DocumentIntegrationScripts() {
    return (
        <noscript>
            <iframe
                src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}`}
                height="0"
                width="0"
                style={{ display: "none", visibility: "hidden" }}
            />
        </noscript>
    );
}
